import { useTRPC } from "@nwga/features/client";
import { JobDetail } from "@nwga/features/jobs/ui";
import { Button } from "@nwga/ui/components/button";
import { Skeleton } from "@nwga/ui/components/skeleton";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ErrorState } from "../../components/error-state.tsx";

export const Route = createFileRoute("/jobs/$businessSlug/$jobSlug")({
	component: JobPage,
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			context.trpc.jobs.byPath.queryOptions(params),
		),
});

function JobPage() {
	const params = Route.useParams();
	const trpc = useTRPC();
	const job = useQuery(trpc.jobs.byPath.queryOptions(params));

	return (
		<div className="mx-auto max-w-3xl px-4 py-8">
			<Button asChild variant="ghost" size="sm" className="-ml-2 mb-6">
				<Link to="/jobs">← All jobs</Link>
			</Button>

			{job.isPending && (
				<div className="space-y-4" aria-busy="true">
					<Skeleton className="h-9 w-3/4" />
					<Skeleton className="h-5 w-1/3" />
					<Skeleton className="h-40 w-full" />
				</div>
			)}

			{job.isError && (
				<ErrorState error={job.error} onRetry={() => void job.refetch()} />
			)}

			{job.isSuccess && <JobDetail job={job.data} />}
		</div>
	);
}
